import React from 'react';

import Button, { ButtonGroup } from '../../library/button/button';

import './confirmation.scss';

interface ConfirmationProps {
  confirmLabel?: string;
  declineLabel?: string;
  handleConfirm: () => void;
  handleDecline: () => void;
  hasOverlay?: boolean;
  layout?: 'horizontal' | 'vertical';
  showSpinner?: boolean;
}

function Confirmation(props: ConfirmationProps) {
  const {
    confirmLabel = 'Yes, Delete ',
    declineLabel = 'No, Keep',
    handleConfirm,
    handleDecline,
    hasOverlay = false,
    layout = 'horizontal',
    showSpinner = false
  } = props;

  return (
    <div
      className="confirmation"
      styleName={hasOverlay ? 'confirmation-overlay' : ''}
    >
      <div className="confirmation__button-group">
        <ButtonGroup layout={layout}>
          <Button isPrimary onClick={handleConfirm} showSpinner={showSpinner}>
            {confirmLabel}
          </Button>
          <Button isSecondary onClick={handleDecline}>
            {declineLabel}
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
}

export default Confirmation;
